import React, { Component, Fragment } from "react";
import SelectCourse from "../../select-course/components/SelectCourse";
import { routesContext } from "../../../shared/routes/routes-context";

export default class SelectCourses extends Component {
  static contextType = routesContext;
  onClickManuallyInput = () => {
    this.context.manuallyHandicapCalculator.navigate();
  };

  getTabLinkMyCourses = () => this.context.handicapCalculatorMyCourses.path;

  getTabLinkPostScore = () => this.context.handicapCalculatorSelectCourse.path;

  render() {
    return (
      <Fragment>
        <div className="container">
          <section className="post-score">
            <SelectCourse
              {...this.props}
              hasManuallyInput={false}
              manuallyHandicapInput={this.onClickManuallyInput}
              navItemLink={this.context.handicapCalculatorCalculator.path}
              tabLinkMyCourses={this.getTabLinkMyCourses}
              tabLinkPostCourse={this.getTabLinkPostScore}
            />
          </section>
        </div>
      </Fragment>
    );
  }
}
